module.exports = __webpack_public_path__ + "static/img/qrcode.8751a3f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/qrcode.jpeg
// module id = RtkR
// module chunks = 0